import template from './inputPercentage.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    id: '@',
    model: '<',
    onChange: '&',
    onBlur: '&',
  },
};
